// Enums and Interface
import { ControlType, Field, FormComponentType, Layout } from '../../../../../models/common/forms/form-field-config';

// Constants
import { DATE_MESSAGE_CONSTANTS } from '../../../../translate-messages/form-control/core';

/**
 * Constant for the date control
 */
export const DateRangeControl: Field = {
  key: 'dateRange',
  type: ControlType.DATE,
  component: FormComponentType.DATEPICKER,
  templateOptions: {
    layout: Layout.VERTICAL,
    label: DATE_MESSAGE_CONSTANTS.LABEL,
    description: '',
    tooltip: '',
    hint: '',
    icon: {
    },
    disabled: false,
  },
  validations: {
    validators: {
    },
    messages: {
    },
  },
  classNames: {
    main: 'col-md-6',
  },
};

